import { createAsyncThunk } from '@reduxjs/toolkit';
import { OfferService } from '../../../epics/common/offer';

export const addOffer = createAsyncThunk('addOffer', (offer) => {
    return OfferService.addOffer(offer);
});
